export const searchKeys = {
  searchRole: 'searchRole',
  searchCandidate: 'searchCandidate',
  searchGroup: 'searchGroup'
};
